module.exports = __webpack_public_path__ + "img/selected.14297340.png";